module.exports = __webpack_public_path__ + "static/media/eis_logo-on-blue.cb0e0fe4.jpg";